import { render, staticRenderFns } from "./RiwayatDraft.vue?vue&type=template&id=2e51ea3a&scoped=true"
import script from "./RiwayatDraft.vue?vue&type=script&lang=js"
export * from "./RiwayatDraft.vue?vue&type=script&lang=js"
import style0 from "./RiwayatDraft.vue?vue&type=style&index=0&id=2e51ea3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e51ea3a",
  null
  
)

export default component.exports